var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Box, Flex, Grid, Icon, Modal, Text, useToast } from '@homeexchange/design';
import React from 'react';
import i18n from '../../i18n';
import { trackShareListing } from '../../utils/utils-ts';
var openInNewTab = function (href) {
    window.open(href, '_blank', 'noopener,noreferrer');
};
var copyToClipboard = function (text) { return __awaiter(void 0, void 0, void 0, function () {
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!((_a = navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText)) return [3 /*break*/, 2];
                return [4 /*yield*/, navigator.clipboard.writeText(text)];
            case 1:
                _b.sent();
                _b.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); };
var appendUtmSource = function (url) {
    if (!url)
        return url;
    var separator = url.includes('?') ? '&' : '?';
    return "".concat(url).concat(separator, "utm_source=share");
};
export var ShareHomeModal = function (_a) {
    var isOpen = _a.isOpen, onClose = _a.onClose, url = _a.url, title = _a.title, pageLocation = _a.pageLocation, homeId = _a.homeId;
    var showToast = useToast().showToast;
    var baseUrl = url !== null && url !== void 0 ? url : (typeof window !== 'undefined' ? window.location.href : '');
    var shareUrl = appendUtmSource(baseUrl);
    var shareTitle = title !== null && title !== void 0 ? title : '';
    var encodedUrl = encodeURIComponent(shareUrl);
    var encodedTitle = encodeURIComponent(shareTitle);
    var encodedTitleAndUrl = encodeURIComponent(shareTitle ? "".concat(shareTitle, " ").concat(shareUrl) : shareUrl);
    var runAndClose = function (method, action) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackShareListing(method, pageLocation, homeId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, action()];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    onClose();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var channels = [
        {
            key: 'copy-link',
            method: 'copy_link',
            label: i18n.t('global:global.copyLink'),
            icon: 'Copy',
            onClick: function () {
                return runAndClose('copy_link', function () { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, copyToClipboard(shareUrl)];
                            case 1:
                                _a.sent();
                                showToast({
                                    status: 'success',
                                    text: i18n.t('home:toast_share_linkCopied_label')
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
            }
        },
        {
            key: 'facebook',
            method: 'facebook',
            label: 'Facebook',
            icon: 'Facebook',
            onClick: function () {
                return runAndClose('facebook', function () {
                    var _a;
                    (_a = window.FB) === null || _a === void 0 ? void 0 : _a.ui({ method: 'share', href: shareUrl, quote: shareTitle });
                });
            }
        },
        {
            key: 'whatsapp',
            method: 'whatsapp',
            label: 'WhatsApp',
            icon: 'WhatsApp',
            onClick: function () {
                return runAndClose('whatsapp', function () { return openInNewTab("https://wa.me/?text=".concat(encodedTitleAndUrl)); });
            }
        },
        {
            key: 'messenger',
            method: 'messenger',
            label: 'Messenger',
            icon: 'Messenger',
            onClick: function () {
                return runAndClose('messenger', function () {
                    var _a;
                    (_a = window.FB) === null || _a === void 0 ? void 0 : _a.ui({ method: 'send', link: shareUrl });
                });
            }
        },
        {
            key: 'email',
            method: 'email',
            label: i18n.t('user:email'),
            icon: 'Envelope',
            onClick: function () {
                return runAndClose('email', function () {
                    window.location.href = "mailto:?subject=".concat(encodedTitle, "&body=").concat(encodedUrl);
                });
            }
        },
        {
            key: 'reddit',
            method: 'reddit',
            label: 'Reddit',
            icon: 'Reddit',
            onClick: function () {
                return runAndClose('reddit', function () {
                    return openInNewTab("https://www.reddit.com/submit?url=".concat(encodedUrl, "&title=").concat(encodedTitle));
                });
            }
        }
    ];
    return (React.createElement(Modal, { isOpen: isOpen, isClosable: true, onClose: onClose, title: i18n.t('global:global.share'), areDividersVisible: false, size: "small" },
        React.createElement(Grid, { nbColumns: { mobile: 2, default: 3 }, gap: "3", isFullWidth: true }, channels.map(function (channel) { return (React.createElement(Box, { key: channel.key, border: true, isCentered: true, isFullWidth: true, size: "small", onClick: channel.onClick, className: "box-share" },
            React.createElement(Flex, { direction: "column", alignItems: "center", gap: "2" },
                React.createElement(Icon, { name: channel.icon, size: "2xl", color: "base" }),
                React.createElement(Text, { size: "sm" }, channel.label)))); }))));
};
